var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{style:('margin-right:' + _vm.mr + 'px')},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(_vm._s(_vm.value))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }